export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.7-2018.19",
  commitId: "376d9ef10cfe0958992175df1248bc0ab98468fc",
  commitTime: "2026-04-07T20:18:19.000Z",
});
